
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credlix-finsight/[newsletter]",
      function () {
        return require("private-next-pages/credlix-finsight/[newsletter].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credlix-finsight/[newsletter]"])
      });
    }
  